import { Routes, Route, Outlet, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './components/Layout'
import { settingsAPI } from './lib/api'

export const applyTheme = (theme) => {
  if (theme && theme !== 'neon-blue') {
    document.documentElement.setAttribute('data-theme', theme)
  } else {
    document.documentElement.removeAttribute('data-theme')
  }
}
import HomePage from './pages/HomePage'
import GamesLibraryPage from './pages/GamesLibraryPage'
import GamesAdminPage from './pages/GamesAdminPage'
import MenuVisibilityAdminPage from './pages/MenuVisibilityAdminPage'
import MaintenanceAdminPage from './pages/MaintenanceAdminPage'
import FilesPage from './pages/FilesPage'
import EventsPage from './pages/EventsPage'
import TournamentsPage from './pages/TournamentsPage'
import ComposPage from './pages/ComposPage'
import TeamsPage from './pages/TeamsPage'
import TeamProfilePage from './pages/TeamProfilePage'
import TournamentMidiPage from './pages/TournamentMidiPage'
import TournamentsLeaderboardPage from './pages/TournamentsLeaderboardPage'
import TournamentTemplatesAdminPage from './pages/TournamentTemplatesAdminPage'
import LanEditionsAdminPage from './pages/LanEditionsAdminPage'
import BrandingSettingsPage from './pages/BrandingSettingsPage'
import LanWizardPage from './pages/LanWizardPage'
import ProgrammePage from './pages/ProgrammePage'
import ProgrammeAdminPage from './pages/ProgrammeAdminPage'
import ScreensControlPage from './pages/ScreensControlPage'
import RegieDashboardPage from './pages/RegieDashboardPage'
import TestflowsPage from './pages/TestflowsPage'
import GhostLoginPage from './pages/GhostLoginPage'
import ScreenReceiverPage from './pages/ScreenReceiverPage'
import { SchermNuStraks, SchermBar, SchermWelkom, SchermScores, SchermServers, SchermToernooi } from './pages/ZaalSchermen'
import AdminServersScreen from './pages/schermen/AdminServersScreen'
import AdminSystemScreen  from './pages/schermen/AdminSystemScreen'
import AdminLiveScreen    from './pages/schermen/AdminLiveScreen'
import AdminNetworkScreen from './pages/schermen/AdminNetworkScreen'
import AdminHealthScreen     from './pages/schermen/AdminHealthScreen'
import AdminProgrammaScreen  from './pages/schermen/AdminProgrammaScreen'
import AdminDeelnemersScreen from './pages/schermen/AdminDeelnemersScreen'
import AdminTornooienScreen  from './pages/schermen/AdminTornooienScreen'
import AdminBarScreen        from './pages/schermen/AdminBarScreen'
import AdminPrijzenScreen    from './pages/schermen/AdminPrijzenScreen'
import AdminBroadcastsScreen from './pages/schermen/AdminBroadcastsScreen'
import AdminContainersScreen from './pages/schermen/AdminContainersScreen'
import AdminStorageScreen    from './pages/schermen/AdminStorageScreen'
import CustomBoardPage    from './pages/CustomBoardPage'
import PlayersPage from './pages/PlayersPage'
import WikiPage from './pages/WikiPage'
import WikiArticlePage from './pages/WikiArticlePage'
import StreamdeckConfigPage from './pages/StreamdeckConfigPage'
import PlayerProfilePage from './pages/PlayerProfilePage'
import UserImportPage from './pages/UserImportPage'
import TournamentDetailsPage from './pages/TournamentDetailsPage'
import ChatPage from './pages/ChatPage'
import GameServersPage from './pages/GameServersPage'
import PollsPage from './pages/PollsPage'
import NetworkToolsPage from './pages/NetworkToolsPage'
import RequireAuth from './components/RequireAuth'
import RequireAdmin from './components/RequireAdmin'
import LoginPage from './pages/LoginPage'
import AdminPage from './pages/AdminPage'
import AdminHubPage from './pages/AdminHubPage'
import ProfilePage from './pages/ProfilePage'
import SettingsPage from './pages/SettingsPage'
import KassaMePage from './pages/KassaMePage'
import TeamRequestsInboxPage from './pages/TeamRequestsInboxPage'
import SetupHubPage from './pages/SetupHubPage'
import TournamentRegiePage from './pages/TournamentRegiePage'
import WreckfestRegiePage from './pages/WreckfestRegiePage'
import ServerRegiePage from './pages/ServerRegiePage'
import StatsPage from './pages/StatsPage'
import ScreenshotsPage from './pages/ScreenshotsPage'
import MusicPage from './pages/MusicPage'
import HelpdeskPage from './pages/HelpdeskPage'
import TicketDetailPage from './pages/TicketDetailPage'
import HelpdeskPanelPage from './pages/HelpdeskPanelPage'
import VoiceChatPage from './pages/VoiceChatPage'
import MiniGamesPage from './pages/MiniGamesPage'
import SnakeGamePage from './pages/games/SnakeGamePage'
import TetrisGamePage from './pages/games/TetrisGamePage'
import PongGamePage from './pages/games/PongGamePage'
import NasGamesPage from './pages/NasGamesPage'
import EventMediaPage from './pages/EventMediaPage'
import SeatsPage from './pages/SeatsPage'
import GameConsolePage from './pages/GameConsolePage'
import BestellenPage from './pages/BestellenPage'
import KempenvisionPage from './pages/KempenvisionPage'
import KempenvisionAdminPage from './pages/KempenvisionAdminPage'
import KempenvisionJuryPage from './pages/KempenvisionJuryPage'
import KempenvisionVotePage from './pages/KempenvisionVotePage'
import KempenvisionStagePage from './pages/KempenvisionStagePage'
import OverlayPage from './pages/OverlayPage'
import KempenvisionControlPage from './pages/KempenvisionControlPage'
import KempenvisionMidiPage from './pages/KempenvisionMidiPage'
import KempenvisionInleverPage from './pages/KempenvisionInleverPage'
import ImageCompoPage from './pages/ImageCompoPage'
import ImageCompoAdminPage from './pages/ImageCompoAdminPage'
import ImageCompoInleverPage from './pages/ImageCompoInleverPage'
import ImageCompoControlPage from './pages/ImageCompoControlPage'
import ImageCompoStagePage from './pages/ImageCompoStagePage'
import TournamentStagePage from './pages/TournamentStagePage'
import ImageCompoMidiPage from './pages/ImageCompoMidiPage'
import SystemHealthPage from './pages/SystemHealthPage'
import AnalyticsPage from './pages/AnalyticsPage'
import BadgeAdminPage from './pages/BadgeAdminPage'
import AdminQrPage from './pages/AdminQrPage'
import KempenvisionTouchPage from './pages/KempenvisionTouchPage'
import ImageCompoTouchPage from './pages/ImageCompoTouchPage'
import ProfileItemsAdminPage from './pages/ProfileItemsAdminPage'
import PrizesPage from './pages/PrizesPage'
import PrizesAdminPage from './pages/PrizesAdminPage'
import AdminRafflePage from './pages/AdminRafflePage'
import FeedbackPage from './pages/FeedbackPage'
import MapvetoPage from './pages/MapvetoPage'
import ModuleGuard from './components/ModuleGuard'

function App() {
  useEffect(() => {
    settingsAPI.getTheme()
      .then(res => applyTheme(res.data.theme))
      .catch(() => {})
  }, [])

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/scherm/:slug" element={<ScreenReceiverPage />} />
      <Route path="/inloggen-als/:token" element={<GhostLoginPage />} />
      <Route path="/zaal/nu" element={<SchermNuStraks />} />
      <Route path="/zaal/bar" element={<SchermBar />} />
      <Route path="/zaal/welkom" element={<SchermWelkom />} />
      <Route path="/zaal/scores" element={<SchermScores />} />
      <Route path="/zaal/servers" element={<SchermServers />} />
      <Route path="/zaal/toernooi" element={<SchermToernooi />} />
      <Route path="/scherm-admin/servers"  element={<AdminServersScreen />} />
      <Route path="/scherm-admin/systeem"  element={<AdminSystemScreen />} />
      <Route path="/scherm-admin/live"     element={<AdminLiveScreen />} />
      <Route path="/scherm-admin/netwerk"  element={<AdminNetworkScreen />} />
      <Route path="/scherm-admin/health"      element={<AdminHealthScreen />} />
      <Route path="/scherm-admin/programma"   element={<AdminProgrammaScreen />} />
      <Route path="/scherm-admin/deelnemers"  element={<AdminDeelnemersScreen />} />
      <Route path="/scherm-admin/tornooien"   element={<AdminTornooienScreen />} />
      <Route path="/scherm-admin/bar"         element={<AdminBarScreen />} />
      <Route path="/scherm-admin/prijzen"     element={<AdminPrijzenScreen />} />
      <Route path="/scherm-admin/broadcasts"  element={<AdminBroadcastsScreen />} />
      <Route path="/scherm-admin/containers"  element={<AdminContainersScreen />} />
      <Route path="/scherm-admin/storage"     element={<AdminStorageScreen />} />
      <Route path="/scherm-invul/:slug"    element={<CustomBoardPage />} />
      <Route path="/kempenvision/stage" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionStagePage /></ModuleGuard>} />
      <Route path="/imagecompo/stage" element={<ModuleGuard moduleKey="imagecompo"><ImageCompoStagePage /></ModuleGuard>} />
      <Route path="/tournaments/:id/stage" element={<ModuleGuard moduleKey="tournaments"><TournamentStagePage /></ModuleGuard>} />
      {/* OBS-overlay browser-source. Transparant, geen auth, geen sidebar/header — puur scorebord.
          URL bv. /overlay/tournament-42?variant=cs16&chroma=%2300FF00 */}
      <Route path="/overlay/channel/:slug" element={<OverlayPage />} />
      <Route path="/overlay/:identifier" element={<OverlayPage />} />
      <Route element={<RequireAuth />}>
        <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="files" element={<ModuleGuard moduleKey="files"><FilesPage /></ModuleGuard>} />
        <Route path="events" element={<ModuleGuard moduleKey="events"><EventsPage /></ModuleGuard>} />
        <Route path="programma" element={<ModuleGuard moduleKey="programme"><ProgrammePage /></ModuleGuard>} />
        {/* Admin/regie-only routes: alleen zichtbaar voor role admin/superadmin.
            Frontend-guard zodat een gewone user geen kapotte admin-shells ziet
            als hij de URL raadt. Backend blokkeert de API's al met 403. */}
        <Route element={<RequireAdmin />}>
          <Route path="programma/admin" element={<ModuleGuard moduleKey="programme"><ProgrammeAdminPage /></ModuleGuard>} />
          <Route path="schermregie" element={<ModuleGuard moduleKey="screens"><ScreensControlPage /></ModuleGuard>} />
          <Route path="regie" element={<RegieDashboardPage />} />
          <Route path="testhub" element={<TestflowsPage />} />
        </Route>
        <Route path="tournaments" element={<ModuleGuard moduleKey="tournaments"><TournamentsPage /></ModuleGuard>} />
        <Route path="compos" element={<ModuleGuard moduleKey="compos"><ComposPage /></ModuleGuard>} />
        <Route path="teams" element={<ModuleGuard moduleKey="teams"><TeamsPage /></ModuleGuard>} />
        <Route path="teams/:teamId" element={<ModuleGuard moduleKey="teams"><TeamProfilePage /></ModuleGuard>} />
        <Route path="tournaments/:id" element={<ModuleGuard moduleKey="tournaments"><TournamentDetailsPage /></ModuleGuard>} />
        <Route path="tournaments/midi" element={<ModuleGuard moduleKey="tournaments"><TournamentMidiPage /></ModuleGuard>} />
        <Route path="tournaments/leaderboard" element={<ModuleGuard moduleKey="tournaments"><TournamentsLeaderboardPage /></ModuleGuard>} />
        <Route element={<RequireAdmin />}>
          <Route path="tournaments/templates" element={<ModuleGuard moduleKey="tournaments"><TournamentTemplatesAdminPage /></ModuleGuard>} />
          <Route path="admin/lan-edities" element={<LanEditionsAdminPage />} />
          <Route path="admin/branding" element={<BrandingSettingsPage />} />
          <Route path="admin/lan-wizard" element={<LanWizardPage />} />
        </Route>
        <Route path="polls" element={<ModuleGuard moduleKey="polls"><PollsPage /></ModuleGuard>} />
        <Route path="wiki" element={<ModuleGuard moduleKey="wiki"><WikiPage /></ModuleGuard>} />
        {/* wiki/:slug vangt ook 'nieuw' — component herkent IS_NEW via slug ===
            'nieuw'. Losse /nieuw route matchte eerder maar liet useParams
            leeg, waardoor de component 'undefined' als slug ophaalde. */}
        <Route path="wiki/:slug" element={<ModuleGuard moduleKey="wiki"><WikiArticlePage /></ModuleGuard>} />
        <Route path="stats" element={<ModuleGuard moduleKey="stats"><StatsPage /></ModuleGuard>} />
        <Route path="screenshots" element={<ModuleGuard moduleKey="screenshots"><ScreenshotsPage /></ModuleGuard>} />
        <Route path="music" element={<ModuleGuard moduleKey="music"><MusicPage /></ModuleGuard>} />
        <Route path="chat" element={<ModuleGuard moduleKey="chat"><ChatPage /></ModuleGuard>} />
        <Route path="voice-chat" element={<ModuleGuard moduleKey="voice_chat"><VoiceChatPage /></ModuleGuard>} />
        <Route path="mini-games" element={<ModuleGuard moduleKey="mini_games"><MiniGamesPage /></ModuleGuard>} />
        <Route path="mini-games/snake" element={<ModuleGuard moduleKey="mini_games"><SnakeGamePage /></ModuleGuard>} />
        <Route path="mini-games/tetris" element={<ModuleGuard moduleKey="mini_games"><TetrisGamePage /></ModuleGuard>} />
        <Route path="mini-games/pong" element={<ModuleGuard moduleKey="mini_games"><PongGamePage /></ModuleGuard>} />
        <Route path="game-servers" element={<ModuleGuard moduleKey="game_servers"><GameServersPage /></ModuleGuard>} />
        <Route path="network-tools" element={<ModuleGuard moduleKey="network_tools"><NetworkToolsPage /></ModuleGuard>} />
        <Route path="helpdesk" element={<ModuleGuard moduleKey="helpdesk"><HelpdeskPage /></ModuleGuard>} />
        <Route path="helpdesk/:id" element={<ModuleGuard moduleKey="helpdesk"><TicketDetailPage /></ModuleGuard>} />
        <Route path="helpdesk-panel" element={<ModuleGuard moduleKey="helpdesk"><HelpdeskPanelPage /></ModuleGuard>} />
        <Route path="nas-games" element={<ModuleGuard moduleKey="nas_games"><NasGamesPage /></ModuleGuard>} />
        <Route path="event-media" element={<ModuleGuard moduleKey="event_media"><EventMediaPage /></ModuleGuard>} />
        <Route path="seats" element={<ModuleGuard moduleKey="seats"><SeatsPage /></ModuleGuard>} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="instellingen" element={<SettingsPage />} />
        <Route path="kassa/mij" element={<KassaMePage />} />
        <Route path="mijn-verzoeken" element={<TeamRequestsInboxPage />} />
        <Route element={<RequireAdmin />}>
          <Route path="admin/setup" element={<SetupHubPage />} />
          <Route path="admin/streamdeck" element={<StreamdeckConfigPage />} />
          <Route path="regie/toernooien" element={<TournamentRegiePage />} />
          <Route path="regie/wreckfest"  element={<WreckfestRegiePage />} />
          <Route path="regie/servers"    element={<ServerRegiePage />} />
          <Route path="admin/deelnemers-import" element={<UserImportPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="admin/hub" element={<AdminHubPage />} />
          <Route path="admin/system-health" element={<SystemHealthPage />} />
          <Route path="admin/analytics" element={<AnalyticsPage />} />
          <Route path="admin/badges"    element={<BadgeAdminPage />} />
          <Route path="admin/qr"        element={<AdminQrPage />} />
          <Route path="admin/profile-items" element={<ProfileItemsAdminPage />} />
          <Route path="prijzenkraam/admin" element={<PrizesAdminPage />} />
          <Route path="admin/raffle" element={<ModuleGuard moduleKey="raffle"><AdminRafflePage /></ModuleGuard>} />
        </Route>
        <Route path="spelers" element={<PlayersPage />} />
        <Route path="spelers/:userId" element={<PlayerProfilePage />} />
        <Route path="prijzenkraam" element={<PrizesPage />} />
        <Route path="feedback" element={<FeedbackPage />} />
        <Route path="games" element={<GamesLibraryPage />} />
        <Route path="admin/games" element={<RequireAdmin><GamesAdminPage /></RequireAdmin>} />
        <Route path="admin/menu"  element={<RequireAdmin><MenuVisibilityAdminPage /></RequireAdmin>} />
        <Route path="admin/maintenance" element={<RequireAdmin><MaintenanceAdminPage /></RequireAdmin>} />
        <Route path="mapveto/:uuid" element={<MapvetoPage />} />
        <Route path="game-console" element={<RequireAdmin><GameConsolePage /></RequireAdmin>} />
        <Route path="bestellen" element={<ModuleGuard moduleKey="kassa"><BestellenPage /></ModuleGuard>} />
        <Route path="kempenvision" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionPage /></ModuleGuard>} />
        <Route element={<RequireAdmin />}>
          <Route path="kempenvision/admin" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionAdminPage /></ModuleGuard>} />
          <Route path="kempenvision/control" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionControlPage /></ModuleGuard>} />
          <Route path="kempenvision/touch" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionTouchPage /></ModuleGuard>} />
          <Route path="kempenvision/midi" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionMidiPage /></ModuleGuard>} />
          <Route path="imagecompo/admin" element={<ModuleGuard moduleKey="imagecompo"><ImageCompoAdminPage /></ModuleGuard>} />
          <Route path="imagecompo/control" element={<ModuleGuard moduleKey="imagecompo"><ImageCompoControlPage /></ModuleGuard>} />
          <Route path="imagecompo/touch" element={<ModuleGuard moduleKey="imagecompo"><ImageCompoTouchPage /></ModuleGuard>} />
          <Route path="imagecompo/midi" element={<ModuleGuard moduleKey="imagecompo"><ImageCompoMidiPage /></ModuleGuard>} />
        </Route>
        <Route path="kempenvision/jury" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionJuryPage /></ModuleGuard>} />
        <Route path="kempenvision/vote" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionVotePage /></ModuleGuard>} />
        <Route path="kempenvision/inleveren" element={<ModuleGuard moduleKey="kempenvision"><KempenvisionInleverPage /></ModuleGuard>} />
        <Route path="imagecompo" element={<ModuleGuard moduleKey="imagecompo"><ImageCompoPage /></ModuleGuard>} />
        <Route path="imagecompo/inleveren" element={<ModuleGuard moduleKey="imagecompo"><ImageCompoInleverPage /></ModuleGuard>} />
        {/* Notificaties zitten in de bell-dropdown en op /home in de "Voor
            {naam}"-tijdlijn — /notifications zelf redirect naar home. */}
        <Route path="notifications" element={<Navigate to="/" replace />} />
        {/* Catch-all zodat onbekende URL's een NL-404 tonen ipv zwart scherm. */}
        <Route path="*" element={<NotFoundInline />} />
      </Route>
      </Route>
    </Routes>
  )
}

function NotFoundInline() {
  return (
    <div className="container mx-auto p-6 space-y-4 text-center">
      <div className="text-6xl font-mono text-muted-foreground/40">404</div>
      <div className="text-lg font-semibold">Pagina niet gevonden</div>
      <p className="text-sm text-muted-foreground">
        Deze URL bestaat niet. Ga terug via de sidebar of{' '}
        <a href="/" className="text-acid hover:underline">naar home</a>.
      </p>
    </div>
  )
}

export default App
